var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EVENT_TYPES, subscribe } from "@stepstone/events-js";
import { CONSENT_COOKIE_AND_LOCALSTORAGE_KEY } from "./types";
export var subscribeConsentLevelChange = function (eventCb) {
    var _a, _b;
    var unsub = subscribe(EVENT_TYPES.CONSENT_MANAGER.USER_CONSENT_LEVEL_CHANGED, eventCb);
    var consentLevel = (_a = localStorage.getItem(CONSENT_COOKIE_AND_LOCALSTORAGE_KEY)) !== null && _a !== void 0 ? _a : (_b = document.cookie
        .split(";")
        .map(function (el) { return el.split("="); })
        .find(function (_a) {
        var key = _a[0];
        return key == CONSENT_COOKIE_AND_LOCALSTORAGE_KEY;
    })) === null || _b === void 0 ? void 0 : _b[1];
    if (consentLevel) {
        var payload = __assign(__assign({}, JSON.parse(consentLevel)), { isInitialState: true });
        eventCb(new CustomEvent(EVENT_TYPES.CONSENT_MANAGER.USER_CONSENT_LEVEL_CHANGED, {
            detail: payload,
        }));
    }
    return unsub;
};
//# sourceMappingURL=subscribeConsentLevelChange.js.map